import { Component } from '@angular/core';

@Component({
  selector: 'app-pass-key-register-form',
  templateUrl: './pass-key-register-form.component.html',
  styleUrl: './pass-key-register-form.component.scss',
  standalone: false
})
export class PassKeyRegisterFormComponent {

}
